<template>
  <div class="wrapper app-content">
    <div class="tilte-text"> 推广位报表 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <div class="form-item">
          <Select v-model="searchForm.app_key" style="width:150px" placeholder="全部推广位">
            <Option v-for="item in appList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
      </template>
      <template>
        <div class="form-item">
          <span class="form-item-tip">下单日期</span>
          <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;"
            @on-change="handelDateChangeStart"></DatePicker>
          <span style="margin-left:10px;margin-right:10px;">至</span>
          <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak" style="width: 150px;"
            @on-change="handelDateChange"></DatePicker>
        </div>

      </template>
      <template>
        <span class="search-btn" @click="appMovieDayStatistics">查询</span>
        <span class="search-btn" @click="reset">重置</span>
      </template>
    </div>
    <div class="content">
      <div class="echart-content">
        <div class="echart-dom" style="max-width: 930px" id="chartLineBox">

        </div>
        <div class="echar-desc">
          <div class="detail-item">
            <span class="detail-badge bg-orange"></span>
            <span class="detail-title">点击数:</span>
            <span class="detail-content">{{ clickNum }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-blue"></span>
            <span class="detail-title">预估订单量:</span>
            <span class="detail-content">{{ validOrderNum }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-badge bg-pink"></span>
            <span class="detail-title">预估收入:</span>
            <span class="detail-content">{{ validIncome }}</span>
          </div>
        </div>
        <div class="echart-info">
          <p class="font-16">报表说明：</p>
          <p class="font-14">1.订单数、订单金额、预估佣金更新都可能有延迟，延迟时间在10分钟左右。</p>
          <p class="font-14">2.本报表显示在指定的时间段内发生的订单状况。</p>
          <p class="font-14">3.本报表显示的数据非最终确认结算的数据。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { appMovieDayStatistics } from '@/api/promotion'
import { getDate } from '@/utils/date'
import { Icon, Table, Page, Button, Select, Option, DatePicker } from 'view-design'
import echarts from 'echarts'
export default {
  name: 'PromotionOrder',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    DatePicker,
    echarts
  },
  data: function () {
    return {
      isAjaxRequest: false,
      appList: [],
      dayList: [],
      clickNum: 0,
      validIncome: 0,
      validOrderNum: 0,
      clickNumList: [],
      validIncomeList: [],
      validOrderNumList: [],
      searchForm: {
        page: 1,
        pagesize: 10,
        app_key: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        start_time: undefined,
        end_time: undefined,
        sort: '-id'
      }
    }
  },
  created() {
    this.$nextTick(() => {
      // const app_key = this.$route.query.app_key
      // if (app_key) this.searchForm.app_key = app_key
      this.appMovieDayStatistics(true)
    })
  },
  mounted: function () { },
  methods: {
    appMovieDayStatistics() {
      const app_key = this.$route.query.app_key
      if (app_key && !this.searchForm.app_key) {
        this.searchForm.app_key = parseInt(app_key)
      }
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      appMovieDayStatistics(searchForm)
        .then(response => {
          this.appList = response.data.appList
          this.dayList = response.data.dayList

          if (this.dayList.length == 0) {
            this.dayList = ['暂无数据']
          }
          this.clickNum = response.data.clickNum
          this.validIncome = response.data.validIncome
          this.validOrderNum = response.data.validOrderNum
          this.clickNumList = response.data.clickNumList
          if (this.clickNumList.length == 0) {
            this.clickNumList = [0]
          }
          this.validIncomeList = response.data.validIncomeList
          if (this.validIncomeList.length == 0) {
            this.validIncomeList = [0]
          }
          this.validOrderNumList = response.data.validOrderNumList
          if (this.validOrderNumList.length == 0) {
            this.validOrderNumList = [0]
          }
          this.initData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    reset() {
      console.log('重置---------------')
      this.searchForm.app_key = ''
      this.searchForm.start_time_bak = ''
      this.searchForm.end_time_bak = ''
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.appMovieDayStatistics()
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      } else {
        return 'bg-white'
      }
    },
    initData: function () {
      this.chartLine = echarts.init(document.getElementById('chartLineBox'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          //设置tip提示
          trigger: 'axis'
        },

        legend: {
          //设置区分（哪条线属于什么）
          data: ['点击数', '预估订单量', '预估收入']
        },
        color: ['#3D9EFC', '#FF8622', '#FF4F76'], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: 'category',
          boundaryGap: false, //坐标轴两边不留白
          data: this.dayList,
          name: '', //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53'
            }
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53'
            }
          },
          type: 'value'
        },
        series: [
          {
            name: '预估订单量',
            data: this.validOrderNumList,
            type: 'line', // 类型为折线图
            lineStyle: {
              // 线条样式 => 必须使用normal属性
              normal: {
                color: '#3D9EFC'
              }
            }
          },
          {
            name: '点击数',
            data: this.clickNumList,
            type: 'line',
            lineStyle: {
              normal: {
                color: '#FF8622'
              }
            }
          },
          {
            name: '预估收入',
            data: this.validIncomeList,
            type: 'line',
            lineStyle: {
              normal: {
                color: '#FF4F76'
              }
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option)
    },
    handelDateChange: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.start_time_bak !== '') {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.end_time_bak !== '') {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
.bg-orange {
  background: #ff8622;
}

.bg-blue {
  background: #3d9efc;
}

.bg-pink {
  background: #ff4f76;
}

.wrapper {
  width: 100%;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .search-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.wrapper .search-wrap .form-item {
  margin-right: 40px;
}

.wrapper .search-wrap .form-item-tip {
  margin-right: 10px;
}

>>>.ivu-select,
>>>.ivu-input {
  margin-bottom: 10px;
}

>>>.ivu-select-selection:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}

>>>.ivu-select-selection:hover {
  border: 1px solid #ff8622 !important;
}

>>>.ivu-select-item-selected,
.ivu-select-item-selected:hover {
  color: #ff8622;
}

>>>.ivu-input:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}

>>>.ivu-date-picker-cells-cell-today em:after {
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ff8622;
  position: absolute;
  top: 1px;
  right: 1px;
}

>>>.ivu-input:hover {
  border-color: #ff8622 !important;
}

>>>.ivu-date-picker-cells-focused em {
  box-shadow: 0 0 0 1px #ff8622 inset;
}

>>>.ivu-date-picker-focused input {
  border-color: #ff8622;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(255, 150, 43, 0.2);
}

>>>.ivu-date-picker-cells-cell:hover em {
  background: #f4e0d1;
}

>>>.ivu-date-picker-cells-focused em {
  box-shadow: #ff8622;
}

>>>.ivu-date-picker-cells-cell-selected em,
.ivu-date-picker-cells-cell-selected:hover em {
  background: #ff8622;
  color: #fff;
}

.wrapper .search-wrap .search-btn {
  background: #ff8622;
  color: #ffffff;
  padding: 6px 30px;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-right: 10px;
}

.wrapper .content {
  border: 1px solid #f2f2f2;
  margin-top: 0.6rem;
  border-radius: 2px;
  padding: 0.4rem;
  display: flex;
  flex-wrap: wrap;
}

.wrapper .content .echart-content {
  width: 100%;
}

.wrapper .content .echart-content #chartLineBox {
  height: 4.74rem;
}

.wrapper .echart-content .echar-desc {
  display: flex;
  padding: 0.4rem;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .echart-content .echar-desc .detail-item {
  margin-right: 0.68rem;
}

.wrapper .echart-content .echar-desc .detail-item .detail-badge {
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 1px #fff;
  box-shadow: 0 0 0 1px #fff;
  width: 8px;
  height: 8px;
  display: inline-block;
  position: relative;
  top: -1px;
  margin-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-title {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  padding-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-content {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.wrapper .echart-content .echart-info {
  padding: 0.4rem;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/report/Index.vue